import { Sidebar } from '@/components/layout/sidebar';
import { useMainContext } from '@/context/main-context';
import { cn } from '@/lib/utils';

export default function DashboardLayout({ children }) {
  const { isOpen } = useMainContext();

  return (
    <>
      <Sidebar />
      <main
        className={cn(
          'min-h-[calc(100vh-50px)] transition-[margin-left] ease-in-out duration-300',
          !isOpen ? 'lg:ml-[90px]' : 'lg:ml-72'
        )}
      >
        {children}
      </main>
    </>
  );
}
